import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth/auth.service';
import { IAuthProfile } from 'src/app/types/interfaces/auth-profile.interface';
import { SharedModule } from 'src/app/_metronic/shared/shared.module';
import { ToastService } from 'src/app/_metronic/shared/components/toast/toast.service';

@Component({
  selector: 'app-login-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, SharedModule],
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  @Output() forgotPasswordClick = new EventEmitter<void>();
  @Output() microsoftLoginClick = new EventEmitter<void>();

  loginForm!: FormGroup;
  showPassword = false;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/)
      ]]
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  getErrorMessage(fieldName: string): string {
    const field = this.loginForm.get(fieldName);
    if (field?.hasError('required')) {
      return this.translate.instant(`LOGIN.VALIDATION.${fieldName.toUpperCase()}_REQUIRED`);
    }
    if (field?.hasError('email')) {
      return this.translate.instant('LOGIN.VALIDATION.EMAIL_INVALID');
    }
    if (field?.hasError('minlength')) {
      return this.translate.instant('LOGIN.VALIDATION.PASSWORD_MIN_LENGTH');
    }
    if (field?.hasError('pattern')) {
       return this.translate.instant('LOGIN.VALIDATION.PASSWORD_PATTERN');
    }
    return '';
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    const { email, password } = this.loginForm.value;

    this.authService.login({ email, password }).subscribe({
      next: (profile: IAuthProfile) => {
        this.isLoading = false;
        this.router.navigate(['/welcome']);
      },
      error: (err) => {
        this.isLoading = false;
        const errorMsg = 'LOGIN.ERROR_MESSAGE';
        this.toastService.error(errorMsg);
        this.cdr.detectChanges();
      }
    });
  }

  onForgotPasswordClick(): void {
    this.forgotPasswordClick.emit();
  }

  onMicrosoftLoginClick(): void {
    this.microsoftLoginClick.emit();
  }
}
